import Image from 'next/image'
import Link from '@components/ui/link'
import { ROUTES } from '@utils/routes'
import { DisplayUploadCareAsset } from '@hooks/useUploadCare'
import { getFeaturedImg } from '@helper/getFeaturedImg'
import { Text } from '@chakra-ui/react'

type SearchProductProps = {
  item: any
}

const SearchProduct: React.FC<SearchProductProps> = ({ item }) => {
  const image = getFeaturedImg(item)
  return (
    <Link
      href={`${ROUTES.PRODUCT}/${item?.slug}`}
      className="group w-full h-auto flex justify-start items-center"
    >
      <div className="relative flex w-12 h-12 rounded-md overflow-hidden flex-shrink-0 cursor-pointer me-4">
        <DisplayUploadCareAsset
          src={image?.uuid}
          type={image?.media_type}
          dimensions={{ width: 48, height: 48 }}
          resize='100x100'
          alt={item.name || 'Product Image'}
          options={{ resize: '48x48' }}
          className="bg-skin-thumbnail object-cover"
        />
      </div>
      <div className="flex items-start flex-col w-full overflow-hidden">
        <Text ml="4" fontWeight="500" fontSize="20px">{item.name}</Text>
      </div>
    </Link>
  )
}

export default SearchProduct
